import { Box, makeStyles, styled } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const ProgressOverlay = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.type === 'dark' ? '#00000099' : '#edf1f699',
  position: 'absolute',
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 99,
}));

export const useStyles = makeStyles((theme) => ({
  circle: {
    stroke: 'url(#linearColors)',
    position: 'absolute',
  },
  toolTip: {
    color: theme.palette.type === 'dark' ? COLORS.WHITE : COLORS.PRIMARY,
    border: '2px solid',
    borderColor: theme.palette.type === 'dark' ? COLORS.DARK_BORDER : COLORS.LIGHT_BORDER,
    background: theme.palette.type === 'dark' ? '' : COLORS.WHITE,
  },
}));
